var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8507.52,-1425.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prayinghands-darkgrey",
    transform: "matrix(0.145417,0,0,0.186342,8104,1366.08)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2774.96,
    y: 316.846,
    width: 220.057,
    height: 171.727,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.87679,0,0,5.36648,-55730.3,-7331.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8513.38,1450.45L8513.38,1431.12C8513.38,1430.76 8513.09,1430.47 8512.73,1430.47C8512.37,1430.47 8512.08,1430.76 8512.08,1431.12L8512.08,1450.52C8512.08,1451.17 8512.66,1451.77 8513.45,1451.77C8513.45,1451.77 8536.73,1451.77 8536.73,1451.77C8537.09,1451.77 8537.38,1451.48 8537.38,1451.12C8537.38,1450.76 8537.09,1450.47 8536.73,1450.47L8513.45,1450.47C8513.42,1450.47 8513.4,1450.46 8513.38,1450.45ZM8515.2,1446.37L8518.92,1442.34C8518.92,1442.34 8522.94,1443.59 8522.94,1443.59L8526.8,1439.17C8526.8,1439.17 8530.89,1442.57 8530.89,1442.57L8535.28,1435.43C8535.47,1435.12 8535.37,1434.72 8535.07,1434.53C8534.76,1434.34 8534.36,1434.44 8534.17,1434.75L8530.57,1440.61C8530.57,1440.61 8526.65,1437.36 8526.65,1437.36L8522.51,1442.1C8522.51,1442.1 8518.53,1440.86 8518.53,1440.86L8514.25,1445.48C8514.01,1445.75 8514.02,1446.16 8514.28,1446.4C8514.55,1446.64 8514.96,1446.63 8515.2,1446.37Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.5aa83d5ec4a8bd9de591fb3c5ec2dd40.svg";
export { ForwardRef as ReactComponent };